module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAABTUlEQVRIie3Vu0tcURDH8Y+rgo0WVhZWgoWdi68qEEklthYh3RZpxEYEC8FOguUWgo1pUqbwH1gkYKuipQmm0HIFCw02PjkwGy57BR97bcQfDOcwM/d877nnnpm2/bUZGU1iA304wB52sYPfuPVMdTSl/0A7NjGKObRF7B/2A7gX9ucxaBbQg36sYDl83ShjAiNh85lnmqG7Ab17CFCK8Sbju8B2WEO9AUo7HIvxQyZ+HrBfqDZ/oqfoDLWwhvoy0PGwdJ7ljnijJQxF8mcMvwDc0BUuYz6VAD/xCSc4RleLgKQ6TtOuEuAj1jGbS2tN1QQoxW9ZL3jx/yrlPO+ARwCLcRMXcpkFAFLN+YZBrOYyCwCk+rEV81ou84VqLhXTGMDf1wJcxxkUprdzDzpzkYLWTmdwhK/R0bLNphWl+vYl9fEEqOB79N8idYjKPelCPdyiTR9mAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/m_icon2.png
// module id = i0sE
// module chunks = 2